import styled, { css, createGlobalStyle } from 'styled-components';

const PROTECTION_MODAL_CARD_SELECTOR = '#gator-protect-protection-modal-card';

export const ModalCardOverride = createGlobalStyle`
  ${({ theme }) => css`
    ${PROTECTION_MODAL_CARD_SELECTOR} {
      border-radius: 24px !important;
      max-height: 662px !important;
      max-width: 800px !important;
      overflow: hidden !important;
    }

    ${PROTECTION_MODAL_CARD_SELECTOR} > div:last-child {
      overflow-y: hidden !important;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      ${PROTECTION_MODAL_CARD_SELECTOR} {
        border-radius: 0 !important;
        max-height: 100vh !important;
      }

      ${PROTECTION_MODAL_CARD_SELECTOR} > div:last-child {
        overflow-y: auto !important;
      }
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[100]};
    border-radius: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 662px;
    margin: 0 auto;
    padding: 56px 48px 40px;
    width: 800px;
    max-width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      height: auto;
      padding: 48px 24px 56px;
      width: 100%;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      padding: 40px 16px 48px;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: ${theme.v3.font.sizes.huge};
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 0;
    text-align: center;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['2xlarge']};
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[40]};
    display: flex;
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 12px 0 0;
    text-align: center;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const Message = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 40px 0 0;
    text-align: center;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin-top: 32px;
    }
  `}
`;

export const GradientCardWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin: 16px auto 0;
    max-width: 504px;
    padding: 0 0 72px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 0 0 70px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin-top: 20px;
      padding: 0 0 86px;
    }
  `}
`;

export const GradientCard = styled.div`
  border-radius: 24px;
  box-shadow: 0 4px 8px 0 rgba(223, 226, 235, 0.22), 0 3px 6px 0 rgba(223, 226, 235, 0.16);
  background: linear-gradient(180deg, #1D5DA2 0%, #0081B6 30%, #00A4BE 58%, #43C2BE 78%, #A7EEC8 100%);
  padding: 28px 40px 32px;
  position: relative;
  width: 100%;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
    padding: 24px 20px 26px;
  }
`;

export const ProductHeader = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: 0 auto 24px;
  width: fit-content;
`;

export const ProductTitleWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: flex-start;
`;

export const ProductTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[100]};
    font-size: 22px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
    text-align: center;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes.large};
    }
  `}
`;

export const ProductSubtitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[95]};
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: -2px 0 0;
    text-align: left;
    width: 100%;
  `}
`;

export const ProBadge = styled.span`
  ${({ theme }) => css`
    background: linear-gradient(90deg, #0171AF 0%, #A0D0D1 100%);
    border-radius: 999px;
    color: ${theme.v3.colors.brand.snappyBlue[98]};
    font-size: 12px;
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    padding: 2px 10px;
  `}
`;

export const Checklist = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0 auto;
  max-width: 100%;
  padding: 0 8px;
  width: fit-content;
`;

export const ChecklistItem = styled.li`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[98]};
    display: flex;
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    gap: 10px;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin-bottom: 8px;
    text-align: left;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const ChecklistIcon = styled.span`
  align-items: center;
  display: inline-flex;
  justify-content: center;

  svg {
    color: #86E3C1;
    fill: #86E3C1;
  }
`;

export const CheckboxWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: ${theme.v3.spacing.nano};
    justify-content: center;
    margin: ${theme.v3.spacing.xs} 0px 0px 0px;

    label {
      border: 1px solid white !important;
      border-radius: ${theme.v3.spacing.quarck} !important;
    }

    input:not(:checked) ~ label {
      background-color: transparent;
    }

    input:checked ~ label {
      border: 1px solid white;
      border-radius: ${theme.v3.spacing.quarck};
      background-color: ${theme.v3.colors.brand.snappyBlue[50]};

      svg {
        fill: ${theme.v3.colors.neutral[100]};
        height: 11px;
        left: -1px;
        position: relative;
        stroke: ${theme.v3.colors.neutral[100]};
        top: 1px;
      }
    }
  `}
`;

export const TermsLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[100]};
    display: inline-flex;
    font-size: ${theme.v3.font.sizes.medium};
    align-items: center;
    justify-content: center;
    gap: 6px;

    a {
      color: ${theme.v3.colors.neutral[100]} !important;
      text-decoration: underline !important;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;

export const Mascot = styled.img`
  bottom: -8px;
  height: auto;
  left: -80px;
  pointer-events: none;
  position: absolute;
  transform: none;
  width: 170px;
  z-index: 2;

  @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
    bottom: -6px;
    left: -24px;
    width: 152px;
  }

  @media (max-width: ${({ theme }) => theme.v3.breakpoints.sm}) {
    bottom: -4px;
    left: -14px;
    width: 124px;
  }
`;
